import { App } from '@app/app'
import { Project } from '@app/project'
import { Whiteboard_List } from '@app/post-lists/whiteboard-list'
import { Week_Grid_List } from '@app/post-lists/week-grid-list'
import { Context } from '@app/context'

console.log( 'hello from TypeScript' )

declare global {
    interface Window {
        app: App
        Project: typeof Project
        Assembly_Grid_List: typeof Week_Grid_List
        Whiteboard_Grid_List: typeof Whiteboard_List
        progress_interval: number
        Context: typeof Context
        ctx: typeof Context
    }
}

window.app = new App()
window.Project = Project
window.Whiteboard_Grid_List = Whiteboard_List
window.Assembly_Grid_List = Week_Grid_List
window.Context = Context
window.ctx = Context
